// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GuestNaviBar_guest-navbar__41Bcz {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  background-color: var(--color-bg);
  transition: background-color var(--duration-base) var(--easing-standard);
}
.GuestNaviBar_guest-navbar__41Bcz .GuestNaviBar_wapper__MqCCo {
  display: flex;
  align-items: center;
  margin-right: 20px;
  width: 200px;
}
.GuestNaviBar_guest-navbar__41Bcz .GuestNaviBar_wapper__img__hDjOe {
  height: 36px;
  width: auto;
}
.GuestNaviBar_guest-navbar__menu__-hxtZ {
  display: flex;
  align-items: center;
  gap: 30px;
  flex: 1 1;
}
.GuestNaviBar_guest-navbar__login__JNVu- {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}
.GuestNaviBar_guest-navbar__item__drJW8 {
  position: relative;
  padding: 0 20px;
  cursor: pointer;
  font-weight: 500;
  color: var(--color-text-muted);
  transition: color var(--duration-base) var(--easing-standard);
  font-size: 20px;
}
.GuestNaviBar_guest-navbar__item__drJW8:hover {
  color: #1890ff;
}
.GuestNaviBar_guest-navbar__item__drJW8.GuestNaviBar_active__SRVz1 {
  color: #1890ff;
}
.GuestNaviBar_guest-navbar__item__drJW8.GuestNaviBar_active__SRVz1:after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 20px;
  transform: none;
  width: calc(100% - 40px);
  height: 3px;
  background-color: #1890ff;
  border-radius: 2px;
}

@media (max-width: 768px) {
  .GuestNaviBar_guest-navbar__41Bcz {
    height: 70px;
  }
  .GuestNaviBar_guest-navbar__menu__-hxtZ {
    gap: 15px;
  }
  .GuestNaviBar_guest-navbar__item__drJW8 {
    font-size: 17px;
    padding: 8px 15px;
  }
}
@font-face {
  font-family: "Pretendard-Regular";
  src: url("https://cdn.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Regular.woff") format("woff");
  font-weight: 400;
  font-style: normal;
}
.GuestNaviBar_guest-navbar__41Bcz {
  font-family: "Pretendard-Regular", sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/pages/Guest/Navigator/GuestNaviBar.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EAEA,iCAAA;EACA,wEAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAAJ;AAEI;EAGE,YAAA;EACA,WAAA;AAFN;AAME;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AALJ;AAQE;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,6DAAA;EACA,eAAA;AANJ;AAQI;EACE,cAAA;AANN;AASI;EACE,cAAA;AAPN;AASM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,wBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAPR;;AAcA;EACE;IACE,YAAA;EAXF;EAaE;IACE,SAAA;EAXJ;EAcE;IACE,eAAA;IACA,iBAAA;EAZJ;AACF;AAiBA;EACE,iCAAA;EACA,gHAAA;EACA,gBAAA;EACA,kBAAA;AAfF;AAkBA;EACE,6CAAA;AAhBF","sourcesContent":[".guest-navbar {\n  display: flex;\n  align-items: center;\n  height: 60px;\n  padding: 0 20px;\n  // Tokenized so dark mode swaps the guest chrome automatically.\n  background-color: var(--color-bg);\n  transition: background-color var(--duration-base) var(--easing-standard);\n\n  .wapper {\n    display: flex;\n    align-items: center;\n    margin-right: 20px;\n    width: 200px;\n\n    &__img {\n      // Height fixed, width auto so the PNG keeps its native aspect ratio.\n      // Same values used in NaviBar so the brand mark is identical across layouts.\n      height: 36px;\n      width: auto;\n    }\n  }\n\n  &__menu {\n    display: flex;\n    align-items: center;\n    gap: 30px;\n    flex: 1;\n  }\n\n  &__login {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-left: auto;\n  }\n\n  &__item {\n    position: relative;\n    padding: 0 20px;\n    cursor: pointer;\n    font-weight: 500;\n    color: var(--color-text-muted);\n    transition: color var(--duration-base) var(--easing-standard);\n    font-size: 20px;\n\n    &:hover {\n      color: #1890ff;\n    }\n\n    &.active {\n      color: #1890ff;\n      \n      &:after {\n        content: '';\n        position: absolute;\n        bottom: -5px;\n        left: 20px;\n        transform: none;\n        width: calc(100% - 40px);\n        height: 3px;\n        background-color: #1890ff;\n        border-radius: 2px;\n      }\n    }\n  }\n}\n\n// 반응형 처리\n@media (max-width: 768px) {\n  .guest-navbar {\n    height: 70px;\n\n    &__menu {\n      gap: 15px;\n    }\n\n    &__item {\n      font-size: 17px;\n      padding: 8px 15px;\n    }\n  }\n}\n\n// 폰트 적용\n@font-face {\n  font-family: 'Pretendard-Regular';\n  src: url('https://cdn.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Regular.woff') format('woff');\n  font-weight: 400;\n  font-style: normal;\n}\n\n.guest-navbar {\n  font-family: 'Pretendard-Regular', sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"guest-navbar": `GuestNaviBar_guest-navbar__41Bcz`,
	"wapper": `GuestNaviBar_wapper__MqCCo`,
	"wapper__img": `GuestNaviBar_wapper__img__hDjOe`,
	"guest-navbar__menu": `GuestNaviBar_guest-navbar__menu__-hxtZ`,
	"guest-navbar__login": `GuestNaviBar_guest-navbar__login__JNVu-`,
	"guest-navbar__item": `GuestNaviBar_guest-navbar__item__drJW8`,
	"active": `GuestNaviBar_active__SRVz1`
};
export default ___CSS_LOADER_EXPORT___;
